import { DefaultState, TableFilters } from 'store/reducers/types';

export const READ_WORKER_REPORT_FILTERS_REQUEST = 'READ_WORKER_REPORT_FILTERS_REQUEST';
export const READ_WORKER_REPORT_FILTERS_SUCCESS = 'READ_WORKER_REPORT_FILTERS_SUCCESS';
export const READ_WORKER_REPORT_FILTERS_FAILURE = 'READ_WORKER_REPORT_FILTERS_FAILURE';

export type WorkerReportFiltersState = DefaultState & {
  contents?: TableFilters;
};

interface ReadWorkerReportFiltersRequest {
  type: typeof READ_WORKER_REPORT_FILTERS_REQUEST;
};

interface ReadWorkerReportFiltersSuccess {
  type: typeof READ_WORKER_REPORT_FILTERS_SUCCESS,
  contents: TableFilters;
};

interface ReadWorkerReportFiltersFailure {
  type: typeof READ_WORKER_REPORT_FILTERS_FAILURE;
};

export type WorkerReportFiltersActionTypes = ReadWorkerReportFiltersRequest | ReadWorkerReportFiltersSuccess | ReadWorkerReportFiltersFailure;